import permissionAccess from "./permission-access.json";

export default {
  permissionAccess,
};
